<script lang="ts">
  import type { TagVariant, TagSize } from '.';

  import IconWrapper, { IconWrapperSize, type IconComponentType } from '$mds/IconWrapper';
  import { useActions, type ActionArray } from '$components/actions';
  import type { Rounded } from '$mds/types';

  export let variant: TagVariant = 'default';
  export let size: TagSize = 'md';
  export let label = 'Label';
  export let icon: IconComponentType | null = null;
  export let iconColor: string | undefined = undefined;
  export let rounded: Rounded | undefined = undefined;
  export let title: string | undefined = undefined;
  export let use: ActionArray = [];
  let className = '';
  export { className as class };

  const sizeClasses: Record<TagSize, string> = {
    sm: 'text-body-5xs px-1 h-5 gap-1',
    md: 'text-body-4xs px-2 h-6 gap-1.5',
    lg: 'text-body-4xs px-2 h-8 gap-1.5',
    xl: 'text-body-2xs px-3 h-8 gap-2'
  };
  const roundedClasses: Record<TagSize, string> = {
    sm: rounded ? rounded : 'rounded',
    md: rounded ? rounded : 'rounded',
    lg: rounded ? rounded : 'rounded-md',
    xl: rounded ? rounded : 'rounded-lg'
  };
  const iconClasses: Record<TagSize, IconWrapperSize> = {
    sm: 'sm',
    md: 'base',
    lg: 'md',
    xl: 'lg'
  };
  const variantClasses: Record<TagVariant, string> = {
    default: 'text-action-ondark-base bg-action-ondark-subtle',
    secondary: 'text-ondark-primary bg-ondark-high',
    dark: 'text-ondark-secondary bg-ondark-low',
    active: 'text-action-ondark-subtle bg-action-ondark-base',
    new: 'text-action-ondark-subtle bg-gradient-new',
    partner: 'tag-gradient-pro',
    pro: 'text-ondark-primary border border-pro-pro-base bg-ondark-medium',
    core: 'text-ondark-primary border border-pro-core-base bg-ondark-medium',
    special: 'text-onlight-primary bg-gradient-shimmer',
    positive: 'text-positive-ondark-base bg-positive-ondark-subtle',
    alert: 'text-alert-ondark-base bg-alert-ondark-subtle',
    disabled: 'text-ondark-subtle bg-ondark-high'
  };
</script>

<div
  class="inline-flex items-center justify-center {className} {roundedClasses[size]} {sizeClasses[size]} {variantClasses[
    variant
  ]}"
  {title}
  use:useActions={use}
>
  {#if icon}
    <IconWrapper {icon} size={iconClasses[size]} class={iconColor} />
    <span>
      <slot>
        {label}
      </slot>
    </span>
  {:else}
    <slot>
      {label}
    </slot>
  {/if}
</div>
